import { apiServer } from './enviroment';
import axios from 'axios';
import Lockr from 'lockr';

//var tokenizedAxios = 

let getToken = () => Lockr.get('token')

const instance = axios.create({ 
    baseURL: apiServer,
    timeout: 9000000,
    headers: {'Authorization': `Bearer ${getToken()}`}
});

export function loginAction(body){
    return axios
    .post(`${apiServer}/login`, body)
    .then(data => data.data)
}

export function sigunpAction(body){
    return axios
    .post(`${apiServer}/users`, body)
    .then(data => data.data)
}

export function recoverAction(body){
    return axios
    .post(`${apiServer}/recover`, body)
    .then(data => data.data)
}

export function resetAction(body, token){
    return axios
    .post(`${apiServer}/reset/${token}`, body)
    .then(data => data.data)
}

export function confirmResetAction(token){
    return axios
    .get(`${apiServer}/reset/${token}`)
    .then(data => data.data)
}

// Logged endpoints

export function changePasswordAction(body){
    return instance.post(`/users/password`, body)
    .then(data => data.data)
}

export function getProfileAction(){
    return instance.get(`/users/me`)
    .then(data => data.data)
}

export function changeProfileAction(body){
    return instance.post(`/users/me`, body)
    .then(data => data.data)
}

export function deleteImage(id){
    return instance.delete(`/images/${id}`)
    .then(data => data.data)
}

export function getUser(id){
    return instance.get(`/users/${id}`)
    .then(response => response.data);
}

export function getUsers(){
    return instance.get(`/users`)
    .then(response => response.data);
}

export function deleteUser(id){
    return instance.delete(`/users/${id}`)
}

export function modifyUser(id, body){
    return instance.put(`/users/${id}`, body)
}

export function modifyUserPassword(id, body){
    return instance.put(`/users/password/${id}`, body)
}

export function fixImagePath(id){
    return `${apiServer}/images/${id}`
}

export function uploadImage(file){
    /*
    let img = document.createElement("img");
    let reader = new FileReader();  

    reader.onload = function(e) {img.src = e.target.result}
    reader.readAsDataURL(file);

    let myCtx = canvas.getContext("2d");
    
    myCtx.drawImage(img, 0, 0);

    let MAX_WIDTH = 800;
    let width = img.width;
    let height = img.height;
    //
    let wpercent = MAX_WIDTH/width
    let hsize = parseInt(height*wpercent)
    //
    width = canvas.width = MAX_WIDTH;
    height = canvas.height = hsize;
    
    let ctx = canvas.getContext("2d");

    ctx.drawImage(img, 0, 0, width, height);

    let dataurl = canvas.toDataURL("image/jpeg");

    let blobBin = atob(dataurl.split(',')[1]);
    let array = [];
    
    for(var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    file = new Blob([new Uint8Array(array)], {type: 'image/jpeg', name: "input.jpeg"});
    */
    //
    let formData = new FormData();
    
    formData.append('file', file) //,file)

    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${getToken()}`
        }
    }

    return axios.post(`${apiServer}/images`, formData, config)
    .then(data => {
        let result = data.data;
        result.path = `${apiServer}/images/${result.id}`;
        return result;
    })
}